import React, { useEffect, useState } from 'react';
import { PhoneIcon } from 'lucide-react';
interface HeaderProps {
  /** Pass null to render the logo as a plain, non-clickable panel. */
  logoHref?: string | null;
  ctaHref?: string;
  /** Hides the phone number and appointment button, leaving a logo-only bar. */
  showActions?: boolean;
}
export function Header({
  logoHref = '#top',
  ctaHref = '#hero-form',
  showActions = true
}: HeaderProps) {
  const [isAtTop, setIsAtTop] = useState(true);
  useEffect(() => {
    function handleScroll() {
      setIsAtTop(window.scrollY <= 8);
    }
    handleScroll();
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const logoPanelClass = `absolute left-4 top-0 flex items-center justify-center bg-brand-teal px-4 shadow-lg transition-[height] duration-300 ease-out sm:left-6 sm:px-5 md:px-6 lg:left-8 ${isAtTop ? 'h-24 w-28 sm:h-32 sm:w-36 md:h-40 md:w-44' : 'h-16 w-28 sm:h-20 sm:w-36 md:w-44'}`;
  const logoImage = <img src="https://cdn.magicpatterns.com/uploads/bUK4G3YzLjUPKikZeYKRwp/GraniteMarbleWorks.png" alt="Granite &amp; Marble Works, Inc." className="max-h-14 w-full object-contain" data-id="element-10" data-mp="6tubx89r0lcx" />;
  return <header className="sticky top-0 z-50 w-full bg-brand-charcoal" data-id="element-11" data-mp="lkbdcrmdvb9t">
      <div className="relative mx-auto flex h-16 max-w-7xl items-center justify-between gap-3 px-4 sm:h-20 sm:gap-6 sm:px-6 lg:px-8" data-id="element-12" data-mp="lmnq8qdaavg0">
        {/* Teal logo panel: aligned with the page content, hanging below the bar at the top
            of the page and collapsing into the bar once the user scrolls. */}
        {logoHref ? <a href={logoHref} aria-label="Granite &amp; Marble Works, Inc. — back to top" className={logoPanelClass} data-id="element-13" data-mp="1wbz36sm1lzn">
            {logoImage}
          </a> : <div className={logoPanelClass} data-id="element-14" data-mp="1dazcjy4hy6ku">{logoImage}</div>}

        {/* Spacer reserving the logo panel's footprint in the bar layout */}
        <div className="w-28 shrink-0 sm:w-36 md:w-44" aria-hidden="true" data-id="element-15" data-mp="3aehmaf0nrz6j" />

        {showActions && <div className="flex items-center gap-3 sm:gap-6" data-id="element-16" data-mp="35fmuwooml2at">
            <a href="tel:+15185842800" className="hidden items-center gap-2 text-sm font-medium text-white/90 transition-colors hover:text-white sm:flex" data-id="element-17" data-mp="3jbs0a84v22f5">
              <PhoneIcon className="h-4 w-4 text-brand-teal" aria-hidden="true" data-id="element-18" data-mp="2qp78x7odxqbl" />
              (518) 584-2800
            </a>
            <a href={ctaHref} className="inline-flex items-center justify-center whitespace-nowrap rounded-md bg-brand-teal px-4 py-2.5 text-xs font-semibold uppercase tracking-wide text-white transition-colors hover:bg-brand-tealDark sm:text-sm" data-id="element-19" data-mp="2mon91wcfg8lr">
              Schedule Appointment
            </a>
          </div>}
      </div>
    </header>;
}